import { createFileRoute } from "@tanstack/react-router";
import ResponseWizard from "@/components/_ResponseWizard";

export const Route = createFileRoute("/_auth/docs_/$documentId/{-$step}")({
  component: ResponseWizard,
});
